const BOOLEAN_LITERALS = new Set(['true', 'false', 'null', 'undefined'])

const isIdentifierStart = (char) => /[a-zA-Z]/.test(char || '')
const isIdentifierPart = (char) => /[a-zA-Z0-9_-]/.test(char || '')
const isNumericLiteral = (value) => /^-?(?:\d+|\d*\.\d+)$/.test(String(value || ''))

const normaliseQuotedValue = (value) => String(value || '')
    .replace(/\\/g, '\\\\')
    .replace(/'/g, '\\\'')

const readHashArgs = (raw) => {
    const source = String(raw || '')
        .replace(/\\"/g, '"')
        .replace(/\\'/g, '\'')
    const args = []
    let index = 0

    while (index < source.length) {
        while (index < source.length && /\s/.test(source[index])) index++
        if (index >= source.length) break

        const keyStart = index
        if (!isIdentifierStart(source[index])) {
            while (index < source.length && !/\s/.test(source[index])) index++
            continue
        }

        index++
        while (index < source.length && isIdentifierPart(source[index])) index++

        const key = source.slice(keyStart, index)
        while (index < source.length && /\s/.test(source[index])) index++
        if (source[index] !== '=') {
            while (index < source.length && !/\s/.test(source[index])) index++
            continue
        }

        index++
        while (index < source.length && /\s/.test(source[index])) index++

        let value = ''
        let quoted = false
        const quoteChar = source[index]

        if (quoteChar === '"' || quoteChar === '\'') {
            quoted = true
            index++

            while (index < source.length) {
                const char = source[index]
                if (char === '\\' && index + 1 < source.length) {
                    value += source[index + 1]
                    index += 2
                    continue
                }
                if (char === quoteChar) {
                    index++
                    break
                }
                value += char
                index++
            }
        } else {
            const valueStart = index
            while (index < source.length && !/\s/.test(source[index])) index++
            value = source.slice(valueStart, index)
        }

        args.push({key, value, quoted})
    }

    return args
}

const normaliseHashArgs = (raw) => {
    if (!raw) return ''

    const args = readHashArgs(raw)
    if (args.length === 0) return String(raw).trim()

    return args.map(({key, value, quoted}) => {
        const rawValue = String(value || '')
        const lower = rawValue.toLowerCase()

        if (!quoted && (BOOLEAN_LITERALS.has(lower) || isNumericLiteral(rawValue))) {
            return `${key}=${rawValue}`
        }

        return `${key}='${normaliseQuotedValue(rawValue)}'`
    }).join(' ')
}

module.exports = {
    normaliseHashArgs
}
